// @ts-nocheck
/* eslint-disable */
import { post, get } from '../requestNew';
import {
    Message
} from '@arco-design/web-react';

export function getNoticeList(params?: any, callback?: any) {
    get<any>('/notice/list', params)
        .then((res: any) => {
            const { code, data, message } = res || {};
            if (code === 200) {
                callback(data)
            } else {
                Message.error(message);
            }
        })
        .catch(e => {
            Message.error('网络错误!');
            console.log(e);
        });
}
